export default __webpack_public_path__ + "static/media/Drawing.dfc3988d.svg";